import http from "../http-common";

class ScheduleService {
    /**
     * Create a new schedule
     * @param {Object} data - Schedule payload
     * @returns {Promise}
     */
    createSchedule(data) {
        return http.post("schedule/create", data);
    }

    /**
     * Update an existing schedule
     * @param {Object} data - Schedule payload with id
     * @returns {Promise}
     */
    updateSchedule(data) {
        return http.put("schedule/update", data);
    }

    /**
     * Get all schedules for a profile
     * @param {string} profileId - Profile ID
     * @param {string} serialNumber - Device serial number
     * @returns {Promise}
     */
    getSchedules(profileId, serialNumber) {
        return http.get(`schedule/list?profileId=${profileId}&serialNumber=${serialNumber}`);
    }

    /**
     * Get a single schedule by ID
     * @param {string} scheduleId - Schedule ID
     * @param {string} profileId - Profile ID
     * @param {string} serialNumber - Device serial number
     * @returns {Promise}
     */
    getScheduleById(scheduleId, profileId, serialNumber) {
        return http.get(`schedule/detail/${scheduleId}?profileId=${profileId}&serialNumber=${serialNumber}`);
    }

    /**
     * Delete a schedule (soft delete)
     * @param {string} scheduleId - Schedule ID
     * @param {Object} data - { profileId, serialNumber }
     * @returns {Promise}
     */
    deleteSchedule(scheduleId, data) {
        return http.delete(`schedule/delete/${scheduleId}`, { data });
    }

    /**
     * Toggle schedule active/inactive status
     * @param {string} scheduleId - Schedule ID
     * @param {Object} data - { profileId, serialNumber, isActive }
     * @returns {Promise}
     */
    toggleScheduleStatus(scheduleId, data) {
        return http.patch(`schedule/toggle-status/${scheduleId}`, data);
    }

    /**
     * Get active schedules for a specific day
     * @param {string} profileId - Profile ID
     * @param {string} serialNumber - Device serial number
     * @param {string} day - Day of the week (monday, tuesday, etc.)
     * @returns {Promise}
     */
    getActiveSchedulesForDay(profileId, serialNumber, day) {
        return http.get(`schedule/active-today?profileId=${profileId}&serialNumber=${serialNumber}&day=${day}`);
    }

    /**
     * Validate schedule for conflicts (without saving)
     * @param {Object} data - Schedule payload
     * @returns {Promise}
     */
    validateSchedule(data) {
        return http.post("schedule/validate", data);
    }
}

export default new ScheduleService();